"use strict";
/**
 * Personal details constants for dropdowns and form options
 * Values must match Firebase database storage format (synced with mobile)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeMarriageType = exports.OTHER_ADDRESS_LABEL = exports.DEFAULT_ADDRESS_LABEL = exports.ADDRESS_LABELS = exports.GENDERS = exports.MARRIAGE_TYPES = void 0;
// Marriage type options - values match mobile app format
exports.MARRIAGE_TYPES = [
    { label: "Out of Community of Property", value: "Out of C.O.P" },
    { label: "In Community of Property", value: "In C.O.P" },
    { label: "Traditional", value: "Traditional" },
];
// Gender options
exports.GENDERS = [
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" },
];
// Address label options for saved addresses
exports.ADDRESS_LABELS = [
    { label: "Home", value: "Home" },
    { label: "Work", value: "Work" },
    { label: "Postal", value: "Postal" },
    { label: "Parents", value: "Parents" },
    { label: "Other", value: "Other" },
];
// Default address label
exports.DEFAULT_ADDRESS_LABEL = "Home";
// Special address label for custom input
exports.OTHER_ADDRESS_LABEL = "Other";
// Normalize marriage type from database to dropdown value
var normalizeMarriageType = function (dbValue) {
    if (!dbValue)
        return "";
    var mapping = {
        "out of c.o.p": "Out of C.O.P",
        "out of cop": "Out of C.O.P",
        "outofcommunityofproperty": "Out of C.O.P",
        "out of community of property": "Out of C.O.P",
        "in c.o.p": "In C.O.P",
        "in cop": "In C.O.P",
        "incommunityofproperty": "In C.O.P",
        "in community of property": "In C.O.P",
        "traditional": "Traditional",
    };
    // Try exact match first (case-insensitive)
    var normalized = mapping[dbValue.toLowerCase()];
    if (normalized)
        return normalized;
    // Check if value already matches a valid option
    var validValues = exports.MARRIAGE_TYPES.map(function (t) { return t.value; });
    if (validValues.includes(dbValue)) {
        return dbValue;
    }
    // Return original if no match
    return dbValue;
};
exports.normalizeMarriageType = normalizeMarriageType;
